import React from "react";
import { useRecoilValue } from "recoil";

import Modal from "components/modal";
import { BASE_ASSETS_URL } from "constants/app";
import useClickToCall from "../useClickToCall";
import { clickToCallAtom } from "../constants";
import { getErrorMessages } from "../utils";

import styles from "./errorView.scss";

export default function ErrorView() {
  const state = useRecoilValue(clickToCallAtom);
  const { dismiss } = useClickToCall();

  const { title, message } = getErrorMessages(state);

  const body = (
    <div className={styles.click_to_call_error_view}>
      <img src={`${BASE_ASSETS_URL}images/error-icon.svg`} />
      <div className={styles.text}>{title}</div>
      <div className={styles.text}>{message}</div>
    </div>
  )

  return <Modal body={body} onCloseClick={dismiss} />
}
